import React, { useEffect, useState } from "react";
import OrganizationApi from "../../../../../api/organization-api";

const WhatsappSettingsTab = ({
  organizationId,
  existingSecrets,
  setExistingSecrets,
  setSuccessMessage,
  refreshWhatsappSenderDetails,
}) => {
  const [twilioAccountSID, setTwilioAccountSID] = useState("");
  const [twilioAuthToken, setTwilioAuthToken] = useState("");
  const [twilioFromPhoneNumber, setTwilioFromPhoneNumber] = useState("");

  const [showTwilioAccountSID, setShowTwilioAccountSID] = useState(false);
  const [showTwilioAuthToken, setShowTwilioAuthToken] = useState(false);
  const [showTwilioFromPhoneNumber, setShowTwilioFromPhoneNumber] = useState(false);

  const [twilioSaving, setTwilioSaving] = useState(false);
  const [twilioSaveError, setTwilioSaveError] = useState("");

  useEffect(() => {
    setTwilioAccountSID(existingSecrets?.twilioAccountSID || "");
    setTwilioAuthToken(existingSecrets?.twilioAuthToken || "");
    setTwilioFromPhoneNumber(existingSecrets?.twilioFromPhoneNumber || "");
  }, [existingSecrets]);

  const handleSaveTwilioCredentials = async (e) => {
    e.preventDefault();
    if (!organizationId) return;
    if (twilioSaving) return;

    setTwilioSaveError("");
    setTwilioSaving(true);
    try {
      const updatedSecrets = {
        ...(existingSecrets || {}),
        twilioAccountSID: twilioAccountSID.trim(),
        twilioAuthToken: twilioAuthToken.trim(),
        twilioFromPhoneNumber: twilioFromPhoneNumber.trim(),
      };

      await OrganizationApi.private.updateOrganization(organizationId, { secrets: updatedSecrets });
      setExistingSecrets(updatedSecrets);
      setSuccessMessage("Twilio credentials updated successfully.");
      setTimeout(() => setSuccessMessage(""), 5000);

      if (typeof refreshWhatsappSenderDetails === "function") {
        refreshWhatsappSenderDetails();
      }
    } catch (error) {
      console.error("Error updating Twilio credentials:", error);
      setTwilioSaveError("Failed to update Twilio credentials.");
    } finally {
      setTwilioSaving(false);
    }
  };

  return (
    <div className="whatsappSettingsTab">
      <h5 className="mb-3">WhatsApp Settings</h5>

      {twilioSaveError ? <div className="alert alert-danger">{twilioSaveError}</div> : null}

      <form onSubmit={handleSaveTwilioCredentials}>
        <div className="form-group mb-3">
          <label htmlFor="twilioAccountSID">Twilio Account SID</label>
          <div className="credentialInputGroup">
            <input
              type={showTwilioAccountSID ? "text" : "password"}
              id="twilioAccountSID"
              className="form-control credentialInput"
              value={twilioAccountSID}
              placeholder="ACXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
              onChange={(e) => setTwilioAccountSID(e.target.value)}
              autoComplete="off"
            />
            <button
              type="button"
              className="btn credentialToggleButton"
              onClick={() => setShowTwilioAccountSID((v) => !v)}
            >
              {showTwilioAccountSID ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <div className="form-group mb-3">
          <label htmlFor="twilioAuthToken">Twilio Auth Token</label>
          <div className="credentialInputGroup">
            <input
              type={showTwilioAuthToken ? "text" : "password"}
              id="twilioAuthToken"
              className="form-control credentialInput"
              value={twilioAuthToken}
              onChange={(e) => setTwilioAuthToken(e.target.value)}
              autoComplete="off"
            />
            <button
              type="button"
              className="btn credentialToggleButton"
              onClick={() => setShowTwilioAuthToken((v) => !v)}
            >
              {showTwilioAuthToken ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <div className="form-group mb-3">
          <label htmlFor="twilioFromPhoneNumber">Twilio "From" Phone Number</label>
          <div className="credentialInputGroup">
            <input
              type={showTwilioFromPhoneNumber ? "text" : "password"}
              id="twilioFromPhoneNumber"
              className="form-control credentialInput"
              value={twilioFromPhoneNumber}
              onChange={(e) => setTwilioFromPhoneNumber(e.target.value)}
              placeholder="+1234567890"
              autoComplete="off"
            />
            <button
              type="button"
              className="btn credentialToggleButton"
              onClick={() => setShowTwilioFromPhoneNumber((v) => !v)}
            >
              {showTwilioFromPhoneNumber ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <div className="buttons chat-new-start mt-0 mb-0">
          <button className="bouncy-button" type="submit" disabled={twilioSaving}>
            <span>{twilioSaving ? "Saving" : "Save credentials"}</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default WhatsappSettingsTab;
